import React, {useContext, useState} from 'react';
import UserContext from '../common/UserContext.js';

// kendo react
import {DropDownButton} from '@progress/kendo-react-buttons';
import {menuIcon} from "@progress/kendo-svg-icons";

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    editUserKey,
    removeUserKey,
    mainMessages,
} from '../../assets/text/MultilingualText.js';

function UserConfigHamburger(props) {
    const {
        userData,
        showEditUser,
        showRemoveUser
    } = props;
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    const [opened, setOpened] = useState(false);

    const openedStyle = {
        padding: 0,
        textAlign: "center",
        color: "var(--keysight-secondary)"
    };
    const closedStyle = {
        padding: 0,
        textAlign: "center",
        color: "var(--color-text-prominent)"
    };
    const anchorAlign = {
        horizontal: "right",
        vertical: "top"
    };
    const popupAlign = {
        horizontal: "left",
        vertical: "top"
    };

    let categories = [
        {
            key: "edit",
            text: localization.toLanguageString(editUserKey, mainMessages[siteLanguageDefault][editUserKey])
        },
        {
            key: "remove",
            text: localization.toLanguageString(removeUserKey, mainMessages[siteLanguageDefault][removeUserKey])
        }
    ];

    const onItemClick = (e) => {
        if (e.item.key === "edit") {
            showEditUser(userData);
        } else if (e.item.key === "remove") {
            showRemoveUser(userData);
        }
    }

    return (
        <td
            className="ksm-hamburger"
            style={opened ? openedStyle : closedStyle}
        >
            <DropDownButton
                svgIcon={menuIcon}
                fillMode={"flat"}
                rounded={null}
                opened={opened}
                popupSettings={{
                    animate: false,
                    popupClass: "ksm-hamburger-dropdown",
                    anchorAlign: anchorAlign,
                    popupAlign: popupAlign
                }}
                items={categories}
                onItemClick={onItemClick}
                onOpen={() => setOpened(!opened)}
                onBlur={() => {setOpened(false)}}
            />
        </td>
    );
}

export default UserConfigHamburger;